module.exports = __webpack_public_path__ + "img/sc5_005.0d1a5204.png";